import { actionTypes } from '../actions/propiedades'

const initial = {
	list: [], //results of search
  siblings: [], //siblings of the current property
  related: [], //related properties of another one
  importantList: [], //relevant properties by neighborhood
  similarProperties: [], // similar properties in other neighborhood
  relevantResidentials: [], //relevants properties by sector
  relevantOffices: [],
  relevantRetails: [],
  relevantIndustries: [],
  relevantGrounds: [],
	listType: 'gallery',
  property_types: [],
  operation_types: [],
  detail: '',
  showModal: false,
  modalType: 'photo',
  infoType: 'info',
  loading: false,
  loadingDetail: false,
  places: [],
  neighborhoodDetail: [],
  order_by: '',
  streetView: ''
}

export default (state = initial, action) => {
  switch (action.type) {

  	case actionTypes.SET_LISTTYPE:
      return Object.assign({}, state, {
        listType: action.value
      })

    case actionTypes.LOADING:
      return Object.assign({}, state, {
        loading: true
      })

    case actionTypes.RECEIVE:
      return Object.assign({}, state, {
        list: action.properties,
        loading: false
      })

    case actionTypes.RECEIVE_DETAIL:
      return Object.assign({}, state, {
        detail: action.property,
        loadingDetail: false
      })

		case actionTypes.RESET_PROPERTY_TYPES:
			return Object.assign({}, state, {
				property_types: []
			})

    case actionTypes.RECEIVE_RELATED:
      return Object.assign({}, state, {
        related: action.related
      })

    case actionTypes.RECEIVE_IMPORTANTS:
      return Object.assign({}, state, {
        importantList: action.list
      })

    case actionTypes.RECEIVE_NOT_IN_LIST:
      return Object.assign({}, state, {
        similarProperties: action.list
      })

    case actionTypes.RECEIVE_RELEVANTS:
      switch (action.id) {
        case 6:
          return Object.assign({}, state, {
            relevantResidentials: action.list
          })
        case 1:
          return Object.assign({}, state, {
            relevantOffices: action.list
          })
        case 3:
          return Object.assign({}, state, {
            relevantRetails: action.list
          })
        case 7:
          return Object.assign({}, state, {
            relevantGrounds: action.list
          })
        case 2:
          return Object.assign({}, state, {
            relevantIndustries: action.list
          })
      }

    case actionTypes.LOADING_DETAIL:
      return Object.assign({}, state, {
        loadingDetail: true
      })

    case actionTypes.LOAD_PROPERTY_TYPES:
      return Object.assign({}, state, {
        property_types: [],
        property_types_loading: true
      })

    case actionTypes.RECEIVE_PROPERTY_TYPES:
      return Object.assign({}, state, {
        property_types: action.types,
        property_types_loading: false
      })

    case actionTypes.RECEIVE_OPERATION_TYPES:
      return Object.assign({}, state, {
        operation_types: action.operations
      })

    case actionTypes.SET_MODALSTATUS:
      return Object.assign({}, state, {
        showModal: !state.showModal,
        modalType: action.modal
    })

    case actionTypes.SET_INFOTYPE:
      return Object.assign({}, state, {
        infoType: action.value
    })

    case actionTypes.SET_PLACES:
      return Object.assign({}, state, {
        places: action.places
    })

    case actionTypes.RECEIVE_NEIGHBORHOOD_DETAIL:
      return Object.assign({}, state, {
        neighborhoodDetail: action.data
    })

    case actionTypes.RECEIVE_SIBLINGS:
      return Object.assign({}, state, {
        siblings: action.data
    })

    case actionTypes.SAVE_ORDER:
      return Object.assign({}, state, {
        order_by: action.value
    })

    case actionTypes.SAVE_STREETVIEW_STATUS:
      return Object.assign({}, state, {
        streetView: action.value
    })

  	default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/propiedades.js